namespace SP {
    export interface ReturnInfo {
        comment: string,
        note: string,
        returnedQty: number;
        warehouseReturnReasonId: string;
        warehouseReturnActionId: string;
        overrideAction: ReturnActionType;
    }
}